const Footer = () => {
    return (
        <footer>
            <div className="container">
                <p>
                    &copy; all rights resrved to{" "}
                    <a href="https://github.com/mohamedhany72">Mohamed Hany</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
